import React from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import TranslationImage from '../images/language-duotone.svg';
import RubriqTranslationStatus from './RubriqTranslationStatus';
var RubriqNoTranslationsMessage = function RubriqNoTranslationsMessage(_ref) {
  var _plans$premium$access, _plans$premium, _plans$preferred_grou, _plans$preferred_grou2, _plans$premium2, _plans$premium3, _plans$preferred_grou3;
  var onTranslateDocument = _ref.onTranslateDocument;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    plans = _useSelector.curie.plans;
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var premiumCount = (_plans$premium$access = plans === null || plans === void 0 || (_plans$premium = plans.premium) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.access) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.features) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.translation) === null || _plans$premium === void 0 ? void 0 : _plans$premium.usesRemaining) !== null && _plans$premium$access !== void 0 ? _plans$premium$access : 0;
  var preferredCount = (_plans$preferred_grou = plans === null || plans === void 0 || (_plans$preferred_grou2 = plans.preferred_group) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.access) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.features) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.translation) === null || _plans$preferred_grou2 === void 0 ? void 0 : _plans$preferred_grou2.usesRemaining) !== null && _plans$preferred_grou !== void 0 ? _plans$preferred_grou : 0;
  var count = 0;
  if (plans !== null && plans !== void 0 && plans.premium && plans !== null && plans !== void 0 && plans.preferred_group) {
    count = premiumCount + preferredCount;
  } else if (plans !== null && plans !== void 0 && plans.premium) {
    count = premiumCount;
  } else {
    count = preferredCount;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: TranslationImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start your first translation"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.no-translated-documents"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('translate document'),
    type: "button",
    className: "not-global btn btn-primary mt-4 rounded-3",
    onClick: function onClick() {
      return onTranslateDocument();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "translate document"
  }))), /*#__PURE__*/React.createElement(RubriqTranslationStatus, {
    isNoTranslationsMessage: true
  }), deepSeekEnabled && (plans === null || plans === void 0 || (_plans$premium2 = plans.premium) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.access) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.features) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.translation) === null || _plans$premium2 === void 0 ? void 0 : _plans$premium2.feature) === 'translation' && (plans === null || plans === void 0 || (_plans$premium3 = plans.premium) === null || _plans$premium3 === void 0 ? void 0 : _plans$premium3.paymentStatus) !== 'trialing' || deepSeekEnabled && (plans === null || plans === void 0 || (_plans$preferred_grou3 = plans.preferred_group) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.access) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.features) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.translation) === null || _plans$preferred_grou3 === void 0 ? void 0 : _plans$preferred_grou3.feature) === 'translation' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      padding: '2px 4px 2px 4px',
      borderRadius: '5px',
      backgroundColor: '#f1f5f9'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "deepseek-china-translation-info"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      padding: '2px 4px',
      borderRadius: '5px',
      backgroundColor: '#f1f5f9',
      marginLeft: '10px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "deepseek-other-translation-info",
    params: {
      count: count
    }
  }))) : '');
};
export default RubriqNoTranslationsMessage;